export default "__VITE_ASSET__kJGrShwf__"